export const getInitialState = () => ({
  data: {
    detailedExams: [],
    haveAllExamsSameCategory: null,
    manuallySelectedExams: [],
    requestedChangeServices: false,
  },
});

export const state = getInitialState();
